/* eslint-disable array-bracket-newline */
import { useState } from 'react';
import Image from '../../atoms/Image';
import Text from '../../atoms/Text';

import noticeIcon from '../../assets/images/notice.svg';

interface WatchlistTabsProps {
  tabs: string[];
  starTab: string;
  activeTab: string;
  setTab(tab: string): void;
  noticeTab?: string;
  noticeKey?: string;
}

const WatchlistTabs = ({
  tabs,
  starTab,
  activeTab,
  setTab,
  noticeTab,
  noticeKey,
}: WatchlistTabsProps) => {
  const [notice, setNotice] = useState(
    noticeKey ? !window.localStorage?.getItem(noticeKey) : false
  );

  const onTabClick = (tab: string) => {
    setTab(tab);
    if (noticeKey && tab === noticeTab && notice) {
      setNotice(false);
      window.localStorage?.setItem(noticeKey, 'true');
    }
  };
  return (
    <div className='watchlist__tabs'>
      <div
        className={`watchlist__tabs__star ${
          activeTab === starTab ? 'icon-star-active' : 'icon-star'
        }`}
        onClick={() => setTab(starTab)}
      />

      {tabs.map((tab, index) => (
        <div
          key={index}
          className={`watchlist__tabs__tab ${
            tab === activeTab ? 'watchlist__tabs__tab--active' : ''
          }`}
          onClick={() => onTabClick(tab)}
        >
          <Text size={14}>{tab}</Text>
          {tab === noticeTab && notice && (
            <Image
              size='xxs'
              src={noticeIcon}
              className='watchlist__row__alert__notice'
            />
          )}
        </div>
      ))}
    </div>
  );
};

export default WatchlistTabs;
